import { createClient } from '@supabase/supabase-js';

import { env } from '@/env';

// Singleton del cliente Supabase. persistSession + autoRefreshToken nos
// dejan al SDK manejar el ciclo de vida de la sesión.
export const supabase = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});
